import { render, staticRenderFns } from "./DomainOut.vue?vue&type=template&id=0818d1ac&scoped=true&"
import script from "./DomainOut.vue?vue&type=script&lang=js&"
export * from "./DomainOut.vue?vue&type=script&lang=js&"
import style0 from "./DomainOut.vue?vue&type=style&index=0&id=0818d1ac&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0818d1ac",
  null
  
)

export default component.exports